import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getTransactionCategory(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: guid
        description: transCatName
      }
      recordCount
    }
  }
`;

export const deliveryTransactionCategoriesWhere = JSON.stringify({
  useInDeliveries: 1,
  isNotActive: 0,
});

export const useGetTransactionCategoriesAsOptionsQuery = () => {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
};

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
}

export const FieldSelectTransactionCategories = ({
  label = 'Κατηγορία Διακίνησης',
  name = 'transCatGuid',
  defaultValues = {},
  size = 'sm',
  where = undefined,
  ...rest
}: LcFsProps) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetTransactionCategoriesAsOptionsQuery}
      height={size === 'lg' ? 32 : '22'}
    />
  );
};

